(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reviewledger-sitewide-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    const componentSelector = '[data-reviewledger-component]';
    const promises = window.__reviewLedgerWidgetPromises || new Map();
    window.__reviewLedgerWidgetPromises = promises;

    const numberFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en');
    const dateFormatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });

    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    const svgIcon = (name) => {
      const paths = {
        close: ['M18 6 6 18', 'm6 6 12 12'],
        previous: ['m15 18-6-6 6-6'],
        next: ['m9 18 6-6-6-6']
      };
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      (paths[name] || []).forEach((pathValue) => {
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', pathValue);
        svg.append(path);
      });
      return svg;
    };

    const labelsFor = (root) => {
      const source = document.querySelector('[data-reviewledger-component="sitewide"]') || root;
      return source.dataset;
    };

    const reviewWord = (count, labels) => count === 1 ? labels.labelReview : labels.labelReviews;

    const starRow = (rating) => {
      const row = element('span', 'rl-stars');
      row.setAttribute('aria-hidden', 'true');
      for (let index = 1; index <= 5; index += 1) {
        const star = element('span', `rl-star${index > rating ? ' is-empty' : ''}`, '★');
        row.append(star);
      }
      return row;
    };

    const formatDate = (value) => {
      const date = new Date(`${value}T00:00:00`);
      return Number.isNaN(date.getTime()) ? value : dateFormatter.format(date);
    };

    const updateLightbox = (dialog, index) => {
      const photos = dialog.__reviewLedgerPhotos || [];
      const total = photos.length;
      if (!total) return;
      const selectedIndex = (index + total) % total;
      const photo = photos[selectedIndex];
      const labels = dialog.__reviewLedgerLabels;
      dialog.__reviewLedgerIndex = selectedIndex;
      const image = dialog.querySelector('[data-rl-lightbox-image]');
      const caption = dialog.querySelector('[data-rl-lightbox-caption]');
      const previous = dialog.querySelector('[data-rl-lightbox-previous]');
      const next = dialog.querySelector('[data-rl-lightbox-next]');
      const thumbnails = dialog.querySelector('[data-rl-lightbox-thumbnails]');
      image.src = photo.url;
      image.alt = `${labels.labelPhoto} ${selectedIndex + 1} ${labels.labelOf} ${total}: ${dialog.__reviewLedgerReviewer}`;
      caption.textContent = `${labels.labelPhoto} ${selectedIndex + 1} ${labels.labelOf} ${total} · ${dialog.__reviewLedgerReviewer}`;
      previous.hidden = total < 2;
      next.hidden = total < 2;
      thumbnails.hidden = total < 2;
      thumbnails.replaceChildren(...photos.map((item, photoIndex) => {
        const button = element('button', `rl-lightbox__thumbnail${photoIndex === selectedIndex ? ' is-active' : ''}`);
        button.type = 'button';
        button.setAttribute('aria-label', `${labels.labelOpenPhoto} ${photoIndex + 1} ${labels.labelOf} ${total}`);
        if (photoIndex === selectedIndex) button.setAttribute('aria-current', 'true');
        const thumbnail = element('img');
        thumbnail.src = item.url;
        thumbnail.alt = '';
        thumbnail.loading = 'lazy';
        thumbnail.decoding = 'async';
        button.append(thumbnail);
        button.addEventListener('click', () => updateLightbox(dialog, photoIndex));
        return button;
      }));
    };

    const ensureLightbox = (labels) => {
      const existing = document.getElementById('ReviewLedgerPhotoLightbox');
      if (existing) return existing;
      const dialog = element('dialog', 'rl-lightbox');
      dialog.id = 'ReviewLedgerPhotoLightbox';
      dialog.setAttribute('aria-label', labels.labelPhoto);
      const panel = element('div', 'rl-lightbox__panel');
      const stage = element('div', 'rl-lightbox__stage');
      const image = element('img', 'rl-lightbox__image');
      image.dataset.rlLightboxImage = '';
      const caption = element('div', 'rl-lightbox__caption');
      caption.dataset.rlLightboxCaption = '';
      const close = element('button', 'rl-lightbox__close');
      close.type = 'button';
      close.setAttribute('aria-label', labels.labelClosePhoto);
      close.append(svgIcon('close'));
      const previous = element('button', 'rl-lightbox__previous');
      previous.type = 'button';
      previous.dataset.rlLightboxPrevious = '';
      previous.setAttribute('aria-label', labels.labelPreviousPhoto);
      previous.append(svgIcon('previous'));
      const next = element('button', 'rl-lightbox__next');
      next.type = 'button';
      next.dataset.rlLightboxNext = '';
      next.setAttribute('aria-label', labels.labelNextPhoto);
      next.append(svgIcon('next'));
      const thumbnails = element('div', 'rl-lightbox__thumbnails');
      thumbnails.dataset.rlLightboxThumbnails = '';
      stage.append(image, caption);
      panel.append(stage, close, previous, next, thumbnails);
      dialog.append(panel);
      close.addEventListener('click', () => dialog.close());
      previous.addEventListener('click', () => updateLightbox(dialog, dialog.__reviewLedgerIndex - 1));
      next.addEventListener('click', () => updateLightbox(dialog, dialog.__reviewLedgerIndex + 1));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('keydown', (event) => {
        if ((dialog.__reviewLedgerPhotos || []).length < 2) return;
        if (event.key === 'ArrowLeft') updateLightbox(dialog, dialog.__reviewLedgerIndex - 1);
        if (event.key === 'ArrowRight') updateLightbox(dialog, dialog.__reviewLedgerIndex + 1);
      });
      document.body.append(dialog);
      return dialog;
    };

    const openLightbox = (photos, index, reviewerName, labels) => {
      const dialog = ensureLightbox(labels);
      dialog.__reviewLedgerPhotos = photos;
      dialog.__reviewLedgerReviewer = reviewerName;
      dialog.__reviewLedgerLabels = labels;
      updateLightbox(dialog, index);
      if (!dialog.open) dialog.showModal();
    };

    const reviewCard = (review, labels) => {
      const card = element('article', 'rl-review-card');
      card.id = `reviewledger-${review.id}`;
      const photos = Array.isArray(review.photos) ? review.photos.filter((item) => item && item.url) : [];

      if (photos.length) {
        const gallery = element('div', 'rl-review-card__gallery');
        gallery.dataset.photoCount = String(photos.length);
        photos.forEach((photo, index) => {
          const button = element('button', 'rl-review-card__photo-button');
          button.type = 'button';
          button.setAttribute('aria-label', `${labels.labelOpenPhoto} ${index + 1} ${labels.labelOf} ${photos.length}: ${review.reviewerName}`);
          const image = element('img', 'rl-review-card__photo');
          image.src = photo.url;
          image.alt = `${labels.labelPhoto} ${index + 1}: ${review.reviewerName}`;
          image.loading = 'lazy';
          image.decoding = 'async';
          button.append(image);
          if (index === 0) button.append(element('span', 'rl-review-card__photo-label', labels.labelPhoto));
          button.addEventListener('click', () => openLightbox(photos, index, review.reviewerName, labels));
          gallery.append(button);
        });
        card.append(gallery);
      }

      const body = element('div', 'rl-review-card__body');
      const rating = element('div', 'rl-review-card__rating');
      rating.append(starRow(review.rating));
      if (review.verifiedPurchase) {
        rating.append(element('span', 'rl-review-card__verified', `✓ ${labels.labelVerified}`));
      }

      body.append(rating);
      if (review.title) body.append(element('h4', 'rl-review-card__title', review.title));
      body.append(element('p', 'rl-review-card__text', review.body));

      const meta = element('footer', 'rl-review-card__meta');
      meta.append(element('strong', '', review.reviewerName));
      if (review.reviewerCountry) meta.append(element('span', '', `· ${review.reviewerCountry}`));
      if (review.experienceDate) {
        meta.append(element('span', '', `· ${labels.labelExperience} ${formatDate(review.experienceDate)}`));
      }
      body.append(meta);

      if (review.businessResponse && review.businessResponse.text) {
        const response = element('div', 'rl-review-card__response');
        response.append(
          element('strong', '', labels.labelBusinessResponse),
          element('p', '', review.businessResponse.text)
        );
        body.append(response);
      }

      const fullReview = element('a', 'rl-review-card__link');
      fullReview.href = `https://minicubez-reviews.com/#review-${encodeURIComponent(review.id)}`;
      fullReview.target = '_blank';
      fullReview.rel = 'noopener noreferrer';
      fullReview.append(
        document.createTextNode(labels.labelReadFull),
        element('span', '', '↗')
      );
      body.append(fullReview);
      card.append(body);
      return card;
    };

    const hydrateScore = (root, score, labels) => {
      const average = Number(score.average || 0);
      const total = Number(score.total || 0);
      root.querySelectorAll('[data-rl-average]').forEach((node) => {
        node.textContent = average.toFixed(1);
      });
      root.querySelectorAll('[data-rl-total]').forEach((node) => {
        node.textContent = numberFormatter.format(total);
      });
      root.querySelectorAll('[data-rl-rating-label]').forEach((node) => {
        node.textContent = labels.labelExcellent;
      });
      root.querySelectorAll('[data-rl-review-word]').forEach((node) => {
        node.textContent = reviewWord(total, labels);
      });
      root.querySelectorAll('[data-rl-stars]').forEach((node) => {
        node.setAttribute('aria-label', `${average.toFixed(1)} out of 5`);
      });
    };

    const hydrateGlobalProof = (score) => {
      const average = Number(score.average || 0).toFixed(1);
      const total = numberFormatter.format(Number(score.total || 0));
      document.querySelectorAll('[data-rl-product-average], [data-rl-feature-average]').forEach((node) => {
        node.textContent = average;
      });
      document.querySelectorAll('[data-rl-product-total], [data-rl-feature-total]').forEach((node) => {
        node.textContent = total;
      });
      document.querySelectorAll('a.review-link__text strong').forEach((ratingText) => {
        const values = ratingText.querySelectorAll(':scope > span');
        if (values[0]) values[0].textContent = average;
        if (values[1]) values[1].textContent = total;
      });
      document.querySelectorAll('a[href="https://minicubez-reviews.com/"]').forEach((link) => {
        if (/\/5/.test(link.textContent || '')) {
          link.textContent = `${average}/5 · ${total} reviews`;
        }
      });
    };

    const hydrateDistribution = (root, distribution) => {
      distribution.forEach((item) => {
        const row = root.querySelector(`[data-rl-distribution="${item.rating}"]`);
        if (!row) return;
        const percentage = Math.max(0, Math.min(100, Number(item.percentage || 0)));
        const fill = row.querySelector('[data-rl-distribution-fill]');
        const text = row.querySelector('[data-rl-distribution-percent]');
        if (fill) fill.style.width = `${percentage}%`;
        if (text) text.textContent = `${percentage}%`;
      });
    };

    const hydrateTopics = (root, topics, labels) => {
      const target = root.querySelector('[data-rl-topics]');
      if (!target) return;
      target.replaceChildren();
      topics.slice(0, 3).forEach((topic) => {
        const card = element('article', 'rl-topic');
        const heading = element('div', 'rl-topic__heading');
        heading.append(
          element('h4', 'rl-topic__name', topic.label),
          element('span', 'rl-topic__mentions', `${numberFormatter.format(topic.mentions)} ${labels.labelMentions}`)
        );
        card.append(heading, element('p', 'rl-topic__description', topic.description));
        target.append(card);
      });
    };

    const hydrateReviews = (root, data, labels) => {
      const target = root.querySelector('[data-rl-review-list]');
      if (!target) return;
      const limit = Number(target.dataset.rlLimit || 3);
      const reviews = target.dataset.rlReviewMode === 'featured' && Array.isArray(data.featuredReviews)
        ? data.featuredReviews
        : data.reviews || [];
      target.replaceChildren(...reviews.slice(0, limit).map((review) => reviewCard(review, labels)));
    };

    const hydrateInlineReview = (data) => {
      const review = Array.isArray(data.featuredReviews) ? data.featuredReviews[0] : null;
      if (!review) return;
      document.querySelectorAll('p > a[href*="minicubez-reviews.com/#review-"]').forEach((link) => {
        link.href = `https://minicubez-reviews.com/#review-${encodeURIComponent(review.id)}`;
        const stars = element('em', '', '★★★★★');
        const title = element('strong', '', `“${review.title}”`);
        link.replaceChildren(stars, document.createTextNode(' '), title, document.createTextNode(` — ${review.reviewerName} ↗`));
      });
    };

    const fetchData = (endpoint) => {
      const requestUrl = new URL(endpoint);
      requestUrl.searchParams.set('rl_widget_version', '2');
      const cacheKey = requestUrl.toString();
      if (!promises.has(cacheKey)) {
        promises.set(
          cacheKey,
          fetch(cacheKey, { mode: 'cors', credentials: 'omit', cache: 'no-store', headers: { Accept: 'application/json' } })
            .then((response) => {
              if (!response.ok) throw new Error(`ReviewLedger request failed: ${response.status}`);
              return response.json();
            })
            .catch((error) => {
              promises.delete(cacheKey);
              throw error;
            })
        );
      }
      return promises.get(cacheKey);
    };

    const configurePagination = (root, data, labels) => {
      const pagination = root.querySelector('[data-rl-pagination]');
      const button = root.querySelector('[data-rl-load-more]');
      const status = root.querySelector('[data-rl-page-status]');
      const target = root.querySelector('[data-rl-review-list]');
      if (!pagination || !button || !status || !target || !data.pagination) return;

      const pageSize = Number(root.dataset.reviewledgerPageSize || data.pagination.limit || 12);
      const total = Number(data.pagination.total || 0);
      const updateState = (page, hasMore) => {
        const shown = target.querySelectorAll('.rl-review-card').length;
        status.textContent = `${labels.labelShowing} ${numberFormatter.format(shown)} ${labels.labelOf} ${numberFormatter.format(total)} ${reviewWord(total, labels)}`;
        button.dataset.rlNextPage = String(page + 1);
        button.hidden = !hasMore;
        button.disabled = false;
        button.textContent = labels.labelLoadMore;
        pagination.hidden = false;
      };

      updateState(Number(data.pagination.page || 1), Boolean(data.pagination.hasMore));
    };

    const loadNextPage = async (root, button) => {
      const labels = labelsFor(root);
      const status = root.querySelector('[data-rl-page-status]');
      const target = root.querySelector('[data-rl-review-list]');
      if (!status || !target) return;

      const pageSize = Number(root.dataset.reviewledgerPageSize || 12);
      const nextPage = Number(button.dataset.rlNextPage || 2);
      const endpoint = new URL(root.dataset.reviewledgerEndpoint);
      endpoint.searchParams.set('page', String(nextPage));
      endpoint.searchParams.set('limit', String(pageSize));
      button.disabled = true;
      button.textContent = labels.labelLoadingMore;

      try {
        const nextData = await fetchData(endpoint.toString());
        target.append(...(nextData.reviews || []).map((review) => reviewCard(review, labels)));
        const total = Number(nextData.pagination.total || 0);
        const shown = target.querySelectorAll('.rl-review-card').length;
        status.textContent = `${labels.labelShowing} ${numberFormatter.format(shown)} ${labels.labelOf} ${numberFormatter.format(total)} ${reviewWord(total, labels)}`;
        button.dataset.rlNextPage = String(Number(nextData.pagination.page || nextPage) + 1);
        button.hidden = !nextData.pagination.hasMore;
        button.disabled = false;
        button.textContent = labels.labelLoadMore;
      } catch (error) {
        button.disabled = false;
        button.textContent = labels.labelLoadMore;
        status.textContent = labels.labelLoadFailed;
      }
    };

    let lastHydratedAt = 0;

    const hydrate = async (root, force = false) => {
      if (root.dataset.reviewledgerHydrated === 'true' && !force) return;
      root.dataset.reviewledgerHydrated = 'true';
      const labels = labelsFor(root);

      try {
        const data = await fetchData(root.dataset.reviewledgerEndpoint);
        hydrateScore(root, data.score, labels);
        hydrateGlobalProof(data.score);
        hydrateReviews(root, data, labels);
        hydrateInlineReview(data);
        if (root.dataset.reviewledgerComponent === 'sitewide') {
          hydrateDistribution(root, data.score.distribution || []);
          hydrateTopics(root, data.summary && data.summary.topics ? data.summary.topics : [], labels);
          if (root.dataset.reviewledgerFullList === 'true') configurePagination(root, data, labels);
        }
        lastHydratedAt = Date.now();
        root.querySelectorAll('[data-rl-loading]').forEach((node) => node.remove());
      } catch (error) {
        root.querySelectorAll('[data-rl-loading]').forEach((node) => node.remove());
        const errorNode = root.querySelector('[data-rl-error]');
        if (errorNode) errorNode.hidden = false;
      }
    };

    const init = (scope = document) => {
      scope.querySelectorAll(componentSelector).forEach((root) => hydrate(root));
    };

    const refresh = () => {
      promises.clear();
      document.querySelectorAll(componentSelector).forEach((root) => hydrate(root, true));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    if (document.documentElement.dataset.reviewledgerPaginationBound !== 'true') {
      document.documentElement.dataset.reviewledgerPaginationBound = 'true';
      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-rl-load-more]');
        if (!(button instanceof HTMLButtonElement) || button.disabled) return;
        const root = button.closest('[data-reviewledger-component="sitewide"]');
        if (!root) return;
        loadNextPage(root, button);
      });
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refresh();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && Date.now() - lastHydratedAt > 60000) refresh();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
